import { attachDocumentToInvoice } from 'services/XeroService'
import { Success, Error } from 'utils/alerts'

/**
 * Handle file attachments to an invoice
 * @param {string} invoiceId - The Xero invoice ID
 * @param {Array} files - Array of files to attach
 * @param {Object} xeroConfig - Xero configuration object
 */
export const handleFileAttachments = async (invoiceId, files, xeroConfig) => {
    if (!files || files.length === 0 || !xeroConfig) {
        console.log('No files to upload or no Xero config')
        return
    }

    try {
        console.log('Uploading files to invoice:', invoiceId)
        console.log('Files to upload:', files)

        // Upload each file sequentially
        for (const file of files) {
            console.log(`Uploading file: ${file.name} (${file.size} bytes)`)
            await attachDocumentToInvoice(xeroConfig.id, {
                invoice_id: invoiceId,
                file: file,
                filename: file.name,
                include_online: true, // Make attachment visible in online invoice
            })
            console.log(`File ${file.name} uploaded successfully`)
        }
        Success('Files attached successfully!')
    } catch (error) {
        console.error('Error attaching files:', error)
        Error(`Failed to attach files: ${error.message || 'Unknown error'}`)
    }
}
